import Vue from 'vue'

const state = Vue.observable({
  isLoggedIn: false,
  balancePoints: 0,
  nickname: '',
  /** 头像图片 http(s) 完整 URL，由 checkLogin 的 user.avatar 写入 */
  avatar: ''
})

export function setAuthState (payload) {
  if (!payload) return
  if (typeof payload.isLoggedIn === 'boolean') {
    state.isLoggedIn = payload.isLoggedIn
  }
  if (typeof payload.balancePoints === 'number') {
    state.balancePoints = payload.balancePoints
  }
  if (typeof payload.nickname === 'string') {
    state.nickname = payload.nickname
  }
  if (typeof payload.avatar === 'string') {
    state.avatar = payload.avatar
  }
}

export function useAuthState () {
  return state
}

